import { loadSessionField } from '../../../auth/sessionProfileStore'
import { authFetch, BASE_BACKEND_URL } from '../../../auth'
import cookie from 'react-cookies'
import { getCurrentDate } from '../../../helpers/formatDate'
import { ReportTabsMap, ReportTabLabels } from './reportTabs'
import { runFileDownload } from '../../../components/downloads/fileDownloadStore'
import { saveReportBlob } from './downloads/reportIndexDownloads'

export async function downloadUserReportCsv({
  csvType,
  startDate,
  endDate,
  searchQuery = '',
  activeTabKey,
  filenameLabelOverride,
  hasPendingSettlementQuery = ''
}) {
  const supervisorName = cookie.load('user_name')
  const businessName = loadSessionField('business')

  const url = `${BASE_BACKEND_URL}/reports/user_reports/download_csv/${csvType}?start_date=${startDate}&end_date=${endDate}&supervisor_name=${encodeURIComponent(supervisorName)}&search=${encodeURIComponent(searchQuery || '')}${hasPendingSettlementQuery || ''}`

  return runFileDownload({
    title: 'Reporte de usuarios en CSV',
    task: async (signal) => {
      if (!csvType) throw new Error('Descarga no disponible para esta pestaña.')
      const res = await authFetch(url, { method: 'GET', signal })
      if (!res?.ok) throw new Error('Error al generar el archivo. Intenta nuevamente.')

      const blob = await res.blob()
      const tabLabel =
        filenameLabelOverride || ReportTabLabels[ReportTabsMap[activeTabKey]] || activeTabKey
      const filename = `ReporteUsuarios${tabLabel}_${businessName}_${getCurrentDate()}.csv`
      saveReportBlob(blob, filename)
      return { filename }
    }
  })
}
